import { GridIcon, ListIcon, RowsIcon } from '@newcore/icons';
import type { SegmentedControlOption } from '@newcore/ui/segmented-control';
import { AppViewMode } from '@/enums/app-view-mode.enums';

export const RECENT_HEADING = 'Recently used';
export const APP_TILE_SKELETON_COUNT = 14;
export const APP_ROW_SKELETON_COUNT = 8;

export const VIEW_MODE_OPTIONS: SegmentedControlOption<AppViewMode>[] = [
  { value: AppViewMode.ICONS, label: 'Icons', icon: GridIcon },
  { value: AppViewMode.CARDS, label: 'Cards', icon: RowsIcon },
  { value: AppViewMode.LIST, label: 'List', icon: ListIcon },
];

export const COLLECTION_CLASSES: Record<AppViewMode, string> = {
  [AppViewMode.ICONS]: 'flex flex-wrap gap-x-12 gap-y-6',
  [AppViewMode.CARDS]: 'grid w-full grid-cols-1 gap-3 sm:grid-cols-2',
  [AppViewMode.LIST]: 'grid w-full grid-cols-1 gap-1',
};
export const NO_FAVORITES_MESSAGE = 'No favorite applications';
export const NO_APPLICATIONS_MESSAGE = 'No applications available';
